const ACRONYMS = {
  'Arsenal': 'ARS',
  'Aston Villa': 'AVL',
  'Bournemouth': 'BOU',
  'Brentford': 'BRE',
  'Brighton': 'BHA',
  'Burnley': 'BUR',
  'Chelsea': 'CHE',
  'Crystal Palace': 'CRY',
  'Everton': 'EVE',
  'Fulham': 'FUL',
  'Leeds': 'LEE',
  'Liverpool': 'LIV',
  'Man City': 'MCI',
  'Man United': 'MUN',
  'Newcastle': 'NEW',
  "Nott'm Forest": 'NFO',
  'Sunderland': 'SUN',
  'Tottenham': 'TOT',
  'West Ham': 'WHU',
  'Wolves': 'WOL',
};

export function teamAcronym(name) {
  return ACRONYMS[name] ?? name;
}

export function replaceTeamNames(str) {
  if (!str) return str;
  if (ACRONYMS[str]) return ACRONYMS[str];
  let result = str;
  for (const [full, short] of Object.entries(ACRONYMS)) {
    result = result.replace(full, short);
  }
  return result;
}
